import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, CircularProgress } from '@material-ui/core';
import Spin from 'components/Spin';
import { Field, Formik, Form } from 'formik';
import React, { useCallback } from 'react';
import { toast } from 'react-toastify';
import { useObservable, useCallbackObservable } from 'react-use-observable';
import { of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ListRadioButtonFormField } from 'v2/components/Shared/FormFields/ListRadioButton';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import { EReproveMotiveId } from 'v2/interfaces/requestManagement/refund';
import refundService from 'v2/services/requestManagement/refund';

import useStyle from './styles';
import ReproveMotiveSchema from './validations';

import type { FormikProps } from 'formik';

interface IValues {
  reprove_motive: string;
  justification: string;
}

export default function ReproveMotive() {
  const classes = useStyle();
  const [open] = useObservable(() => refundService.getReproveMotive(), []);
  const [currentRefund] = useObservable(() => refundService.getCurrentRefund(), []);
  const [listReproveMotive] = useObservable(() => refundService.listReproveMotive(), []);

  const closeDetails = useCallback(() => {
    refundService.closeReproveMotive();
  }, []);

  const [onSubmit] = useCallbackObservable(
    ({ reprove_motive, justification }: IValues, { setSubmitting, resetForm }: FormikProps<IValues>) => {
      setSubmitting(true);
      return refundService.reprove(currentRefund, reprove_motive, justification).pipe(
        tap(() => {
          setSubmitting(false);
          resetForm();
          refundService.closeReproveMotive();
          toast.success('Solicitação reprovada com sucesso!');
        }),
        catchError((err) => {
          setSubmitting(false);
          toast.error(err);
          return of(true);
        })
      );
    },
    [currentRefund]
  );

  return (
    <Dialog aria-labelledby='customized-dialog-title' open={open} maxWidth={'sm'} fullWidth>
      <Formik
        initialValues={{
          reprove_motive: '',
          justification: '',
        }}
        onSubmit={onSubmit}
        validationSchema={ReproveMotiveSchema}
      >
        {({ isSubmitting, isValid, dirty, values }) => {
          const shouldDisableBtn = isSubmitting || !isValid || !dirty;
          const otherReasonSelected = values.reprove_motive === EReproveMotiveId.OTHER_REASON;

          const checkBoxFormat = listReproveMotive.map((item) => ({
            label: item.description,
            value: item.id,
          }));

          return (
            <Form>
              <DialogTitle id='customized-dialog-title'>
                <div className={classes.dialogTitle}>Motivo da Reprova</div>
              </DialogTitle>
              <DialogContent dividers>
                {open && !listReproveMotive ? (
                  <Spin />
                ) : (
                  <Grid container spacing={2} direction='row' justify='flex-start' alignItems='center'>
                    <Grid item xs={12}>
                      <Field id='reprove_motive' name='reprove_motive' options={checkBoxFormat} component={ListRadioButtonFormField} />
                    </Grid>
                    {otherReasonSelected && (
                      <Grid item xs={12}>
                        <Field
                          id='justification'
                          name='justification'
                          component={TextFormField}
                          placeholder='Descreva o motivo da reprova do pedido de reembolso. (Lembre-se de que essa informação será direcionada ao cliente.)'
                          multiline
                        />
                      </Grid>
                    )}
                  </Grid>
                )}
              </DialogContent>
              <DialogActions>
                <Button color='primary' onClick={closeDetails} disabled={isSubmitting}>
                  Cancelar
                </Button>
                <Button variant='contained' className={classes.buttonReprove} type='submit' disabled={shouldDisableBtn}>
                  Reprovar Reembolso
                  {isSubmitting && <CircularProgress size={15} style={{ color: '#192542', marginLeft: 10 }} />}
                </Button>
              </DialogActions>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
}
